module.exports = __webpack_public_path__ + "img/control_main.63c2af37.png";